"use client"

import * as React from "react"
import * as TooltipPrimitive from "@radix-ui/react-tooltip"

import { cn } from "@/lib/utils"
import { useTooltipPreferences } from "@/user-preferences/use-tooltip-preferences"

const TooltipProvider = TooltipPrimitive.Provider

function Tooltip({
    disableHoverableContent = true,
    ...props
}: React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Root>) {
    return (
        <TooltipPrimitive.Root
            {...props}
            delayDuration={0}
            disableHoverableContent={disableHoverableContent}
        />
    )
}
Tooltip.displayName = TooltipPrimitive.Root.displayName

const TooltipTrigger = TooltipPrimitive.Trigger

const TooltipContent = React.forwardRef<
    React.ElementRef<typeof TooltipPrimitive.Content>,
    React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ className, sideOffset = 4, ...props }, ref) => {
    const { tooltipsPreferences } = useTooltipPreferences()
    const animated_entry = tooltipsPreferences?.animatedEntry ?? true
    const animated_exit = tooltipsPreferences?.animatedExit ?? true

    return (
    <TooltipPrimitive.Portal >
        <TooltipPrimitive.Content
            ref={ref}
            sideOffset={sideOffset}
            className={cn(
                "z-[999] rounded-md bg-popover shadow-lg px-3 py-1.5 text-xs text-foreground !pointer-events-none",
                animated_entry && [
                    "animate-in fade-in-0 zoom-in-95",
                    "data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
                ],
                animated_exit &&
                    "data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95",
                className
            )}
            {...props}
        >

            {props.children}

            <TooltipPrimitive.Arrow className="fill-popover relative -top-px" />

        </TooltipPrimitive.Content>
    </TooltipPrimitive.Portal>
    )
})
TooltipContent.displayName = TooltipPrimitive.Content.displayName

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider }
